/**
 * Copyright (c) 2024 Securisea, Inc.
 * All rights reserved.
 *
 * This is unpublished, propriety, internal
 * source code of Securisea, Inc.
 * No license is provided to any third parties.
 * If found outside of a Securisea, Inc. environment
 * report to bounty@securisea.com for a possible cash reward
 * and promptly delete all files.
 */
import { getCookie, setCookie } from "../../api/apiClient";
import { fetchCurrentUser } from "../../pages/finish-login";

export const getUserInfo = () => {
  return JSON.parse(getCookie("user_data") || "{}");
};

export const isUserAllowed = () => {
  const userInfo = getUserInfo();
  return userInfo.access_enabled === true;
};

export const isUserCompliantWithTOSRequirements = () => {
  fetchCurrentUser();
  const userInfo = getUserInfo();

  if (userInfo.must_accept_tos === false) {
    return true;
  }

  if (
    userInfo.must_accept_tos === true &&
    userInfo.has_accepted_tos === false
  ) {
    return false;
  }

  return true;
};
